<template>
  <div class="main-container">
    <v-toolbar
        flat
        tile
        class="box"
        style="background-color:transparent"
    >
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="pl-0">
        ข้อมูลลูกค้า
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn
          depressed
          @click="$router.push({path: '/setting/customer/create'})"
          color="success"
      >เพิ่มข้อมูลลูกค้า
      </v-btn>
      <v-btn @click="showFilter = !showFilter" icon>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
    </v-toolbar>
    <div class="mx-2 box box-2" style="min-height: 100%;">
      <splitpanes style="height: 100%">
        <pane :size="showFilter ? 80 : 100" style="overflow: auto" class="pl-2 pb-4">
          <v-card
              class="rounded-lg elevation-2 mr-2"
              outlined
              tile
          >
            <v-data-table
                :loading="loading"
                loading-text="Loading... Please wait"
                :headers="header"
                :items="customers"
                :options.sync="options"
                :server-items-length="totalCount"
                :footer-props="footerProps"
                :header-props="{ sortIcon: null }"
                disable-sort
                @click:row="goCustomerDetail"
            >

            </v-data-table>
          </v-card>
        </pane>
        <pane :size="showFilter ? 20 : 0" class="pb-4">
          <v-card
              class="pa-2 rounded-lg elevation-2"
              outlined
              tile
          >
            <h4 class="font-weight-regular">ค้นหา</h4>
            <v-text-field
                dense
                outlined
                placeholder="กรอกข้อมูลที่ต้องการค้นหา"
                class="rounded my-3"
                hide-details
                v-model="search"
            ></v-text-field>
            <h4 class="font-weight-regular my-3">ค้นหาตามวันที่เพิ่มข้อมูลลูกค้า</h4>
            <DatePicker placeholder="วันเริ่มต้น" v-model="start_date" clearable/>
            <v-card elevation="0" height="10px"/>
            <DatePicker placeholder="วันสิ้นสุด" v-model="end_date" clearable/>
            <v-divider class="my-4"/>
          </v-card>
        </pane>
      </splitpanes>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {Splitpanes, Pane} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import DatePicker from "@/components/DatePicker";
import _ from 'lodash';

export default {
  name: "CustomerList",
  components: {DatePicker, Splitpanes, Pane},
  data() {
    return {
      loading: false,
      customers: [],
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
        multiSort: false,
        mustSort: false,
      },
      footerProps: {
        'items-per-page-options': [10, 20, 50, 100],
      },
      header: [
        {text: 'ชื่อ', value: 'name'},
        {text: 'เบอร์โทร', value: 'tel'},
        {text: 'ที่อยู่', value: 'customer_address'},
        {text: 'เครดิต', value: 'credit', align: 'center'},
        {text: 'ประเภท', value: 'type', align: 'center'},
        {text: 'เงินเติม', value: 'prepaid', align: 'center'},
        {text: 'ถูกเพิ่มเมื่อ', value: 'create_date', align: 'left'},
      ],
      showFilter: false,
      search: '',
      start_date: '',
      end_date: ''
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchCustomers()
      },
      deep: true,
      immediate: true,
    },
    search: _.debounce(function () {
      const onFirstPage = this.options.page === 1
      this.$set(this.options, 'page', 1)
      if (onFirstPage) {
        this.fetchCustomers()
      }
    }, 400),
    start_date() {
      if (this.options.page !== 1) {
        this.$set(this.options, 'page', 1)
      } else {
        this.fetchCustomers()
      }
    },
    end_date() {
      if (this.options.page !== 1) {
        this.$set(this.options, 'page', 1)
      } else {
        this.fetchCustomers()
      }
    },
  },
  methods: {
    fetchCustomers() {
      this.loading = true
      const page = this.options.page || 1
      const itemsPerPage = this.options.itemsPerPage || 20
      const params = {
        page,
        page_size: itemsPerPage,
      }
      const q = (this.search || '').trim()
      if (q) {
        params.search = q
      }
      if (this.start_date) {
        params.start_date = this.start_date
      }
      if (this.end_date) {
        params.end_date = this.end_date
      }
      axios.get('/api/accounts/customer/', {params})
          .then(res => {
            this.customers = res.data.data
            this.totalCount = res.data.count
          })
          .catch(e => {
            const status = e.response ? `${e.response.status} ${e.response.statusText}` : (e.message || 'network error')
            this.$store.state.snackbar = {
              text: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง ข้อความที่ระบบแจ้ง : ' + status,
              visible: true,
              color: 'error'
            }
          }).finally(() => {
        this.loading = false
      })
    },
    goCustomerDetail(row) {
      let routeData = this.$router.resolve({path: `/setting/customer/${row.id}`});
      window.open(routeData.href, '_blank');
    },
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: transform .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  /*width: 50%;*/
  transform: translateX(100%);
}

::v-deep .v-input__append-inner {
  margin-top: 4px;
}
</style>
